import { LoggerURL, AuthorizationLogger } from '../../_config'
import axios from 'axios'
import { CookiesGet, CookiesSet } from '../helpers'

export default class UserActionLogger {
  constructor () {
    if (!this.cookieSession) {
      this.cookieSession = this.mathRandom
    }
    if (!this.storageKey) {
      this.storageKey = this.mathRandom
    }
    this.sessionID = this.mathRandom
    this.send()
  }

  /**
   * @returns {string}
   */
  // eslint-disable-next-line class-methods-use-this
  get mathRandom () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0
      const v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }

  /**
   * Запись сессии пользователя
   * @param value
   */
  set sessionID (value) {
    // eslint-disable-next-line no-underscore-dangle
    this._session = value
  }

  /**
   * Получать сессию пользователя
   * @returns {string}
   */
  get sessionID () {
    return this._session
  }

  /**
   * Получить cookies
   * @returns {*}
   */
  get cookieSession () {
    return CookiesGet('_usr_log')
  }

  /**
   * Записать в cookies
   * @param value
   */
  set cookieSession (value) {
    CookiesSet('_usr_log', value)
  }

  /**
   * Уникальныый ключь пользователя
   * @returns {*}
   */
  get storageKey () {
    return localStorage.getItem('_usr_uid')
  }

  /**
   * Записать Уникальныый ключь пользователя
   * @param value
   */
  set storageKey (value) {
    localStorage.setItem('_usr_uid', value)
  }

  /**
   * Возвращает текущий URL
   * @returns {string}
   */
  get currentURL () {
    return window.location.href
  }

  /**
   * Возвращает текущий currentURI
   * @returns {string}
   */
  get currentURI () {
    return window.location.pathname
  }

  /**
   * Возвращает последний элемент URI
   * @returns {string}
   */
  get lastPath () {
    const array = this.currentURI.split('/')
    return array[array.length - 1]
  }

  /**
   * Возвращает значение поля
   * @returns {*}
   */
  get filedValue () {
    return this.value
  }

  /**
   * Записывает значение поля
   * @param value
   */
  set filedValue (value) {
    this.value = value
  }

  /**
   * Возвращает название поля
   * @returns {string}
   */
  get fieldName () {
    return this.name ? this.name : ''
  }

  /**
   * Записывает название поля
   * @param value
   */
  set fieldName (value) {
    this.name = value
  }

  /**
   * Возвращает пользователя
   * @returns {Object|string}
   */
  get userID () {
    return this._user ? this._user : 0
  }

  /**
   * Запись данных пользователя
   * @param obj
   */
  set userID (obj) {
    this._user = Number(obj)
  }

  async send (type = 'PageVisit') {
    // if (process.env.NODE_ENV === 'production') {
    //   const query = {
    //     type,
    //     url: this.currentURL,
    //     page: this.lastPath,
    //     field_name: this.fieldName,
    //     value: this.filedValue,
    //     user_id: this.userID,
    //     session_id: this.sessionID,
    //     cookie_session: this.cookieSession,
    //     uniq_key: this.storageKey
    //   }
    //
    //   const headers = {
    //     headers: {
    //       Authorization: `Bearer ${AuthorizationLogger}`,
    //       'Content-Type': 'application/json'
    //     }
    //   }
    //
    //   await axios.post(`${LoggerURL}/api/v1/create`, query, headers)
    //
    //   this.filedValue = ''
    //   this.fieldName = ''
    // }
  }
}



// WEBPACK FOOTER //
// /src/core/library/UserActionLogger.js